<template>
  <div>
    <div class="rj-page-card">
      <div class="rj-page-card__content">
        <el-form ref="searchForm" :inline="true" class="" :model="searchForm">
          <el-form-item label="批次付款申请编号:">
            <el-input v-model.trim="searchForm.batchApplyId" placeholder="请输入批次付款申请编号" />
          </el-form-item>
          <el-form-item label="批次发货编号:">
            <el-input v-model.trim="searchForm.batchDeliveryId" placeholder="请输入批次发货编号" />
          </el-form-item>
          <el-form-item label="申请人:">
            <el-input v-model.trim="searchForm.applicant" placeholder="请输入申请人" />
          </el-form-item>
          <el-form-item label="申请时间:" prop="applyStartTime">
            <div class="rj-flex">
              <div class="rj-flex__item">
                <el-date-picker
                  v-model="searchForm.applyStartTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  clearable
                />
              </div>
              <div style="display: inline-block;width: 10px;text-align: center">
                -
              </div>
              <div class="rj-flex__item">
                <el-date-picker
                  v-model="searchForm.applyEndTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                  clearable
                />
              </div>
            </div>
          </el-form-item>
          <el-form-item label="客户名称:">
            <el-input v-model.trim="searchForm.agentName" placeholder="请输入客户名称" />
          </el-form-item>
          <el-form-item label="订单合同号:">
            <el-input v-model.trim="searchForm.contractNum" placeholder="请输入订单合同号" />
          </el-form-item>
          <el-form-item label="下单主体:">
            <el-input v-model.trim="searchForm.businessEntity" placeholder="请输入下单主体" />
          </el-form-item>
          <el-button type="primary" :loading="isLoading" @click="searchData">
            搜索
          </el-button>
          <el-button type="default" @click="resetForm">
            重置
          </el-button>
          <el-button type="primary" :loading="isLoading" @click="exportProduct">
            导出明细
          </el-button>
        </el-form>
      </div>
    </div>
    <el-table v-loading="isLoading" :data="tableData" border style="width: 100%">
      <el-table-column prop="batchApplyId" label="批次请款申请编号" align="left">
        <template v-slot="{ row }">
          <el-button type="text" @click="handleDetail(row)">{{ row.batchApplyId }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="batchDeliveryId" label="批次发货编号" align="left" />
      <el-table-column prop="applyTime" label="申请时间" align="left" />
      <el-table-column prop="applicant" label="申请人" align="left" />
      <el-table-column prop="contractNum" label="订单合同号" align="left">
        <!-- 多合同号时使用省略号并配合 Tooltip 展示完整内容 -->
        <template v-slot="{ row }">
          <el-tooltip
            v-if="shouldShowContractTooltip(row.contractNum)"
            effect="dark"
            :content="getContractTooltip(row.contractNum)"
            placement="top"
          >
            <span class="contract-ellipsis">{{ getContractDisplay(row.contractNum) }}</span>
          </el-tooltip>
          <span v-else class="contract-ellipsis">{{ getContractDisplay(row.contractNum) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="businessEntity" label="下单主体" align="left" />
      <el-table-column prop="agentName" label="客户名称" align="left" />
      <el-table-column prop="batchDeliveryTotalAmount" label="批次请款总金额" align="left">
        <template v-slot="{ row }">
          {{ row.batchDeliveryTotalAmount ? Number(row.batchDeliveryTotalAmount).toFixed(2) : '0.00' }}
        </template>
      </el-table-column>
      <el-table-column prop="salesType" label="付款方式" align="left" />
      <!-- <el-table-column prop="hopeOrderTime" label="希望开单时间" align="left" /> -->
      <el-table-column prop="applyStatus" label="申请状态" align="left" />
    </el-table>
    <div style="text-align: right;margin-top: 10px">
      <el-pagination
        :page-sizes="[10, 20, 30, 40]"
        :page-size.sync="page.pageSize"
        :current-page.sync="page.currentPage"
        layout="total, prev, pager, next, jumper,sizes"
        :total="page.total"
        @size-change="handerSizeChange"
        @current-change="handerCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { GetIntelPaymentBatchApplyList, ExportIntelPaymentBatchApplyList } from '@/API/BatchManagement.js';
import { downloadBlobFile } from '@/libs/util';

const INVALID_CHAR_PATTERN = /[^\w\u4e00-\u9fa5\s-]/g;
export default {
  data () {
    const defaultSearchForm = {
      batchApplyId: '',
      batchDeliveryId: '',
      applicant: '',
      applyStartTime: '',
      applyEndTime: '',
      agentName: '',
      contractNum: '',
      businessEntity: '',
      applyStatus: 1
    };
    return {
      searchForm: { ...defaultSearchForm },
      defaultSearchForm,
      isLoading: false,
      tableData: [],
      pickerOptions: {
        disabledDate: () => false
      },
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      activeFilters: {}
    };
  },
  methods: {
    // 当搜索框输入时，移除除中文、字母、数字、下划线、空格和短横线外的符号
    buildFilterParams (source = this.searchForm) {
      const sanitized = {};
      // 去除中文、数字、字母、下划线、空格、短横线之外的符号
      Object.keys(source).forEach((key) => {
        const value = source[key];
        if (value === 0 || value) {
          sanitized[key] = typeof value === 'string' ? value.replace(INVALID_CHAR_PATTERN, '').trim() : value;
        }
      });
      return sanitized;
    },
    handleDetail (row) {
      this.$router.push({
        path: `/PendingBatchPaymentDetails/${row.batchApplyId}`,
        query: {
          status: true
        }
      });
    },
    // 将合同号整理为列表并控制 Tooltip 展示逻辑
    shouldShowContractTooltip (contractValue) {
      const parts = this.normalizeContractList(contractValue);
      return parts.length > 1;
    },
    getContractDisplay (contractValue) {
      const parts = this.normalizeContractList(contractValue);
      if (!parts.length) return '';
      return parts.length > 1 ? `${parts[0]}...` : parts[0];
    },
    getContractTooltip (contractValue) {
      const parts = this.normalizeContractList(contractValue);
      return parts.join(' , ');
    },
    normalizeContractList (contractValue) {
      if (contractValue === null || contractValue === undefined) return [];
      if (Array.isArray(contractValue)) {
        return contractValue
          .map((item) => (item === null || item === undefined ? '' : item.toString().trim()))
          .filter(Boolean);
      }
      return contractValue
        .toString()
        .split(/[，,\n;]/)
        .map((item) => item.trim())
        .filter(Boolean);
    },
    async getData (includeFilters = true) {
      // 分页切换调用 getData(false) 时不再携带搜索条件，
      // 只在显式搜索或重置时发送完整筛选参数,保证切换页码时不触发搜索操作
      this.isLoading = true;
      try {
        const baseParams = {
          applyStatus: 1,
          pageIndex: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        let filters = {};
        if (includeFilters) {
          filters = this.buildFilterParams();
          this.activeFilters = { ...filters };
        } else {
          filters = this.activeFilters || {};
        }
        const params = { ...filters, ...baseParams };
        const res = await GetIntelPaymentBatchApplyList(params);
        const list = res.data.data.list || [];
        this.tableData = list;
        this.page.total = res.data.data.total || 0;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    searchData () {
      this.page.currentPage = 1;
      this.getData(true);
    },
    resetForm () {
      if (this.$refs.searchForm) {
        this.$refs.searchForm.resetFields();
      }
      Object.assign(this.searchForm, this.defaultSearchForm);
      this.activeFilters = {};
      this.page.currentPage = 1;
      this.getData(true);
    },
    handerSizeChange (size) {
      this.page.pageSize = size;
      this.page.currentPage = 1;
      this.getData(false);
    },
    handerCurrentChange (page) {
      this.page.currentPage = page;
      this.getData(false);
    },
    exportProduct () {
      const hasActiveFilters = this.activeFilters && Object.keys(this.activeFilters).length;
      const filters = hasActiveFilters ? this.activeFilters : this.buildFilterParams();
      const params = {
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize,
        batchApplyId: filters.batchApplyId,
        batchDeliveryId: filters.batchDeliveryId,
        contractNum: filters.contractNum,
        applyStartTime: filters.applyStartTime,
        applyEndTime: filters.applyEndTime,
        applicant: filters.applicant,
        businessEntity: filters.businessEntity,
        agentName: filters.agentName,
        applyStatus: 1
      };
      ExportIntelPaymentBatchApplyList(params).then((res) => {
        downloadBlobFile({
          content: res.data,
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          fileName: '已确认批次付款明细'
        });
      });
    }
  },
  mounted () {
    this.getData();
  }
};
</script>
<style scoped>
.contract-ellipsis {
  display: inline-block;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>
